import { useEffect, useState } from "react";

export const useLocalStorage = (
  key: string,
  defaultValue?: string,
): [string, (value: string) => void] => {
  let initialValue = localStorage.getItem(key) || defaultValue;
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    localStorage.setItem(key, value);
  }, [value, key]);

  return [value, setValue];
};
